import React, { Component } from "react";

import PublishedContentTable from "./PublishedContentsTable";
import { publishService } from "./service/publishContents.service";
import WelcomeScreen from "../../../../_utils/WelcomeScreen";

class ManageUserPublication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      submitting: false,
      formError: null,
      data: null,
      selectedRow: null,
      hasParams: false,
      error: null,
      pageNum: 0,
      pageSize: 10,
      showModal: false,
      notResetMode: false,
      showData: true,
      isFirstTimeUser: localStorage.getItem("visited") || false,
      run: false,
      showNextJoyRide: false,
    };
  }
  componentDidMount() {
    const { pageNum, pageSize } = this.state;
    this.getAllPosts({ pageNum: pageNum + 1, pageSize });
    if (this.state.isFirstTimeUser) {
      this.setState({ isFirstTimeUser: false });
    } else {
      localStorage.setItem("visited", true);
      this.setState({ isFirstTimeUser: true });
    }
  }

  getAllPosts = params => {
    this.setState({ fetching: true });
    publishService
      .getAllInstructorPosts(params)
      .then(response => {
        response &&
          this.setState({
            data: response,
            pages: Math.ceil(response.count / params.pageSize),
            error: null,
            fetching: false,
          });
      })
      .catch(error => this.setState({ error, fetching: false }));
  };

  selectRow = selectedRow => {
    this.setState({ selectedRow: selectedRow.original, hasParams: true });
  };
  fetchData = () => {
    const { pageNum, pageSize, filterParams } = this.state;
    let params = { pageNum: pageNum + 1, pageSize };
    if (filterParams) {
      params = { ...filterParams, ...params };
    }
    this.getAllPosts(params);
  };

  setPageNumber = pageIndex => {
    this.setState({ pageNum: pageIndex }, () => this.fetchData());
  };

  setPageSize = (pageSize, pageIndex) => {
    this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
  };

  filterData = params => {
    const filterParams = {
      ...this.state.filterParams,
      ...params,
    };
    this.setState({ filterParams, pageNum: 0 }, () => this.fetchData());
  };
  //=======================TOUR GUIDE SECTION===============================
  skipTutorialGuide = () => {
    this.setState({ isFirstTimeUser: false, run: false });
  };

  startTutorialGuide = () => {
    this.setState({ isFirstTimeUser: false, run: true, showNextJoyRide: true });
  };

  setNextJoyRide = () => {
    this.setState({ showNextJoyRide: false });
  };
  routeChange = () => {
    this.props.history.push({
      pathname: `/userdrafts`,

      state: { run: true },
    });
  };
  render() {
    const {
      fetching,
      data,
      pages,
      pageNum,
      pageSize,
      error,
      hasParams,
      selectedRow,
      filterParams,
      isFirstTimeUser,
      showNextJoyRide,
    } = this.state;

    return (
      <div>
        <WelcomeScreen
          isFirstTimeUser={isFirstTimeUser}
          skipTutorialGuide={this.skipTutorialGuide}
          startTutorialGuide={this.startTutorialGuide}
        />
        <PublishedContentTable
          fetching={fetching}
          hasParams={hasParams}
          selectedRow={selectedRow}
          data={data}
          selectRow={this.selectRow}
          error={error}
          getAllPosts={this.getAllPosts}
          pages={pages}
          page={pageNum}
          pageSize={pageSize}
          filterData={this.filterData}
          setPageNumber={this.setPageNumber}
          setPageSize={this.setPageSize}
          postId={selectedRow}
          filterParams={filterParams}
          showNextJoyRide={showNextJoyRide}
          setNextJoyRide={this.setNextJoyRide}
          routeChange={this.routeChange}
        />
      </div>
    );
  }
}

export default ManageUserPublication;
